import { RouteComponentProps, withRouter } from "react-router";
import { AppActionCreators, ApplicationState, AppState } from "../../store";
import React from "react";
import { IAuthService } from "../../services/Interfaces/IAuthService";
import { ICaseService } from "../../services/Interfaces/ICaseService";
import { IAppUserService } from "../../services/Interfaces/IAppUserService";
import { IOrganizationService } from "../../services/Interfaces/IOrganizationService";
import { ITranslatorService } from "../../services/Interfaces/ITranslatorService";
import { AppContext, ApplicationContext } from "../../context/Contexts";
import { ScaleLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from 'react-redux';
import { Appointment, Case, CaseComment, NotificationItem } from "../../interfaces/Case";
//import { MavoNotification } from "../../interfaces/Vehicle";
import { Button, Grid, IconButton, List, ListItem } from '@material-ui/core';
import NotificationsDisplayItem from "./NotificationsDisplayItem";
import AppointmentNewInNotificationItem from "./AppointmentNewInNotificationItem";
import CaseNewInNotificationItem from "./CaseNewInNotificationItem";
import CaseMessageNotificationItemForPopUp from "./CaseMessageNotificationItemForPopUp";
import { NotificationType, UserNotification } from "../../interfaces/UserNotificationsUpdate";
import UserNotificationForPopUpItem from "./UserNotificationForPopUpItem";

export interface ExternalNotificationProps {
  onClick?: () => void;
  isCz: boolean;
}

type NotificationsDisplayProps = { appState: AppState } & typeof AppActionCreators &
  RouteComponentProps &
  ExternalNotificationProps;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface INotificationDisplayState {}

class NotificationsDisplay extends React.PureComponent<
   NotificationsDisplayProps,
   INotificationDisplayState
> {
  private authService!: IAuthService;
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appUserService!: IAppUserService;
  private organizationService!: IOrganizationService;

  static contextType = ApplicationContext;  


  public render() {
    this.authService = (this.context as AppContext).authenticationService;
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appUserService = (this.context as AppContext).appUserService;
    this.organizationService = (this.context as AppContext).organizationService;
    
    const mappedComments: NotificationItem[] = this.props.isCz ? [] : this.props.appState.userNotifications
      .filter((notification: UserNotification) => notification.type === NotificationType.Comment)
      .map((comment: UserNotification) => ({
        dateCreated: new Date(comment.dateCreation), // Ensure Date object
        type: 'comment',
        entity: comment,
        isInPopup: true // Indicate that this is for popup display
    }));
    
    const mappedCaseNewInNotifications: NotificationItem[] = this.props.appState.userNotifications
      .filter((notification: UserNotification) => notification.type === NotificationType.Case)
      .map((casenewIn: UserNotification) => ({
          dateCreated: new Date(casenewIn.dateCreation),
          type: 'caseNewIn',
          entity: casenewIn,
          isInPopup: true
      }));
    
    const mappedAppointmentNotifications: NotificationItem[] = this.props.appState.userNotifications
      .filter((notification: UserNotification) => notification.type === NotificationType.Appointment)
      .map((appt: UserNotification) => ({
        dateCreated: new Date(appt.dateCreation), // Ensure Date object
        type: 'appointment',
        entity: appt,
        isInPopup: true // Indicate that this is for popup display
    }));
    
    const mappedMavoNotifications: NotificationItem[] = this.props.appState.userNotifications
      .filter((notification: UserNotification) => notification.type < NotificationType.Case)
      .map((notification: UserNotification) => ({
        dateCreated: new Date(notification.dateCreation), // Ensure Date object
        type: 'mavo',
        entity: notification,
        isInPopup: true // Indicate that this is for popup display
    }));

    
    // Combine all arrays into one
    const allNotifications: NotificationItem[] = [
      
        ...mappedAppointmentNotifications,
        ...mappedCaseNewInNotifications,
        ...mappedComments,
        ...mappedMavoNotifications
    ];
    
    // Sort descending by dateCreated
    const allNotificationsSorted: NotificationItem[] = allNotifications.sort(
        (a, b) => b.dateCreated.getTime() - a.dateCreated.getTime()
    );

    return (<React.Fragment>
        <List className="p-0">
        {
          allNotificationsSorted.map( (item, index) => 
          {  
            switch(item.type) {
              case 'mavo':
                return (
                  <ListItem divider key={index} style={{backgroundColor: !item.entity.read ? '#f7f7fc' : 'inherit'}}>
                    <UserNotificationForPopUpItem                    
                        {...this.props}                    
                        item = {item}
                        index= {index}>
                    </UserNotificationForPopUpItem>
                  </ListItem>
                );

              case 'appointment':
                return (
                  <ListItem divider key={index} style={{ backgroundColor: !item.entity.read ? '#f7f7fc' : 'inherit' }}>
                    <AppointmentNewInNotificationItem                    
                        {...this.props}                    
                        item = {item}
                        index= {index}>
                    </AppointmentNewInNotificationItem>
                  </ListItem>
                );

              case 'caseNewIn':
                return (
                  <ListItem divider key={index} style={{backgroundColor: !item.entity.read ? '#f7f7fc' : 'inherit'}}>
                    <CaseNewInNotificationItem                    
                        {...this.props}                    
                        item = {item}
                        index= {index}>
                    </CaseNewInNotificationItem>
                  </ListItem>
                );

              case 'comment':
                return (
                  <ListItem divider key={index}>
                    <CaseMessageNotificationItemForPopUp                    
                        {...this.props}                    
                        item = {item}
                        index= {index}>
                    </CaseMessageNotificationItemForPopUp>
                  </ListItem>
                );

              default:
                return null;
            }

          })
        }
      </List>
    </React.Fragment>)  
    }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: ExternalNotificationProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  AppActionCreators,
  mergeProps
)(withRouter(NotificationsDisplay as any));